<template>
	<v-btn
		icon
		v-on:click="toggleStatus"
		:loading="inAction"
	>
		<template v-if="isLiked">
			<v-icon title="Pašalinti iš pamėgtų">mdi-heart</v-icon>
		</template>
		<template v-else>
			<v-icon title="Pridėti į pamėgtus">mdi-heart-outline</v-icon>
		</template>
	</v-btn>
</template>

<script>
	import ServiceHelper from "../../../../../helpers/ServiceHelper";

	export default {
		props: {
			service: Object
		},
		data: function(){
			var data = {
				isLiked: this.service.liked,
				inAction: false
			};
			return data;
		},
		methods: {
			toggleStatus: function(){
				this.inAction = true;
				ServiceHelper.toggleLikedStatus(this.service).then(function(){
					this.isLiked = !this.isLiked;
					console.warn("TODO! Pranešti, kad pasikeitė serviso pamėgimo statusas!"); // Pvz. aktualu kai turime servisų filtravimą pagal pamėgimą...
					this.inAction = false;
				}.bind(this), function(){
					this.inAction = false;
					this.$vBus.$emit("show-message", "error");
				}.bind(this));
			}
		}
	}
</script>